import React from 'react';
import { NavigationSidebar } from '@ygtechnologies/bygr-frontend-component-library';
import {
    faUsers,
    faSignOut,
    faBuilding,
    faUsersCrown,
    faChartArea,
    faQuestionCircle,
    faFileInvoiceDollar,
    faUserPlus,
    faClipboardListCheck,
    faPlug,
} from '@fortawesome/pro-light-svg-icons';

interface SidebarProps {}

const Sidebar: React.FC<SidebarProps> = () => {
    return (
        <NavigationSidebar>
            {/* <NavigationSidebar.InternalLink to="/" icon={faHome} text="Start page" /> */}
            <NavigationSidebar.InternalLink to="/statistics" icon={faChartArea} text="Statistics" />

            <NavigationSidebar.InternalLink to="/users" icon={faUsers} text="Users" />
            <NavigationSidebar.InternalLink to="/projects" icon={faBuilding} text="Projects" />
            <NavigationSidebar.InternalLink to="/profiles" icon={faUsersCrown} text="Profiles" />
            <NavigationSidebar.InternalLink to="/invitations/profile" icon={faUserPlus} text="Invitations" />

            <NavigationSidebar.InternalLink to="/licenses" icon={faFileInvoiceDollar} text="Licenses" />
            <NavigationSidebar.InternalLink to="/features" icon={faClipboardListCheck} text="Features" />
            {/* <NavigationSidebar.InternalLink to="/electricity-suppliers" icon={faPlug} text="Electricity Suppliers" />*/}

            <NavigationSidebar.Spacer />
            <NavigationSidebar.InternalLink to="/about" icon={faQuestionCircle} text="About" />
            <NavigationSidebar.InternalLink to="/logout" icon={faSignOut} text="Log out" />
        </NavigationSidebar>
    );
};

export default Sidebar;
